export default __webpack_public_path__ + "static/media/massup_grid_xl.6403fe65.jpg";